// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --fp-bg: #576d7b;
  --fp-surface: #f2f3f8;
  --fp-surface-2: #9aa0b8;
  --fp-surface-3: #eba556;
  --fp-surface-4: #dadada;
  --fp-border: rgba(255, 255, 255, 0.07);
  --fp-border-h: rgba(255, 255, 255, 0.14);
  --fp-accent: #4f8ef7;
  --fp-accent-dim: rgba(79, 142, 247, 0.12);
  --fp-text: #ffffff;
  --fp-text-2: #9aa0b8;
  --fp-text-3: #5a6080;
  --fp-radius: 10px;
  --fp-transition: 180ms cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: "Titillium", sans-serif;
}

.fp-header ion-toolbar {
  --background: #576d7b;
  --border-color: #576d7b;
  --color: var(--fp-text);
}

.fp-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--fp-text);
  letter-spacing: -0.3px;
}

.fp-subtitle {
  font-size: 12px;
  color: var(--fp-text);
  font-weight: 400;
  margin-top: 1px;
}

.fp-toolbar {
  --background: var(--fp-surface);
  --border-color: var(--fp-border);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px 8px;
}

.fp-search {
  --background: var(--fp-surface-2);
  --border-radius: 8px;
  --box-shadow: none;
  --color: var(--fp-text);
  --placeholder-color: var(--fp-text-3);
  --icon-color: var(--fp-text-3);
  --clear-button-color: var(--fp-text-3);
  font-size: 13px;
  flex: 1;
}

.role-chip {
  margin: 0;
  height: 32px;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}

.role-chip.role-admin {
  --background: rgba(79, 142, 247, 0.12);
  --color: #4f8ef7;
  border: 1px solid rgba(79, 142, 247, 0.25);
}

.role-chip.role-restricted {
  --background: rgba(245, 166, 35, 0.1);
  --color: #f5a623;
  border: 1px solid rgba(245, 166, 35, 0.2);
}

.role-chip ion-icon {
  font-size: 14px;
}

.fp-content {
  --background: --ion-background-color;
  flex: 1;
  overflow: hidden;
}

.fp-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 12px;
  color: --ion-text-color;
  font-size: 13px;
}

.fp-loading ion-spinner {
  --color: var(--fp-accent);
}

.fp-body {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.fp-sidebar {
  width: 240px;
  min-width: 240px;
  border-right: 1px solid --ion-color-primary;
  overflow-y: auto;
  padding: 12px 0;
  background: #e4e4e4;
}

.fp-sidebar::-webkit-scrollbar {
  width: 3px;
}

.fp-sidebar::-webkit-scrollbar-thumb {
  background: --ion-color-primary;
  border-radius: 2px;
}

@media (max-width: 540px) {
  .fp-sidebar {
    display: none;
  }
}

.fp-section-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.8px;
  color: var(--fp-text-3);
  text-transform: uppercase;
  padding: 4px 16px 8px;
  margin: 0;
}

.fp-tree-row {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding-right: 12px;
  cursor: pointer;
  border-radius: 0;
  transition: background var(--fp-transition);
  font-size: 13px;
  color: var(--fp-text-2);
  -webkit-user-select: none;
          user-select: none;
}

.fp-tree-row:hover:not(.fp-tree-locked) {
  background: var(--fp-surface-3);
  color: var(--fp-text);
}

.fp-tree-row.fp-tree-active {
  background: var(--fp-accent-dim);
  color: var(--fp-accent);
}

.fp-tree-row.fp-tree-active .fp-tree-icon-active {
  color: var(--fp-accent);
}

.fp-tree-row.fp-tree-locked {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.fp-tree-toggle {
  font-size: 12px;
  color: var(--fp-text-3);
  flex-shrink: 0;
  transition: transform var(--fp-transition);
  cursor: pointer;
  padding: 4px;
}

.fp-tree-toggle:hover {
  color: var(--fp-text);
}

.fp-tree-toggle-spacer {
  width: 20px;
  flex-shrink: 0;
}

.fp-tree-icon {
  font-size: 15px;
  flex-shrink: 0;
  color: var(--fp-text-3);
  transition: color var(--fp-transition);
}

.fp-tree-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.fp-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fp-breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--fp-border);
  font-size: 12px;
  color: var(--fp-text-3);
  flex-shrink: 0;
  flex-wrap: wrap;
  background: var(--fp-surface);
}

.fp-breadcrumb ion-icon {
  font-size: 13px;
}

.fp-breadcrumb .bc-sep {
  color: var(--fp-text-3);
  margin: 0 2px;
}

.fp-breadcrumb .bc-item {
  cursor: pointer;
  transition: color var(--fp-transition);
}

.fp-breadcrumb .bc-item:hover {
  color: var(--fp-accent);
}

.fp-breadcrumb .bc-current {
  color: var(--fp-text-2);
  cursor: default;
}

.fp-breadcrumb .bc-current:hover {
  color: var(--fp-text-2);
}

.fp-file-area {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

.fp-file-area::-webkit-scrollbar {
  width: 4px;
}

.fp-file-area::-webkit-scrollbar-thumb {
  background: var(--fp-border);
  border-radius: 2px;
}

.fp-folder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 8px;
  margin-bottom: 20px;
}

.fp-folder-card {
  background: var(--fp-surface-4);
  border: 1px solid var(--fp-border);
  border-radius: var(--fp-radius);
  padding: 14px 12px;
  cursor: pointer;
  transition: all var(--fp-transition);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fp-folder-card:hover:not(.fp-folder-locked) {
  background: var(--fp-surface-3);
  border-color: var(--fp-border-h);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.fp-folder-card.fp-folder-locked {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.fp-folder-icon {
  font-size: 22px;
  color: var(--fp-accent);
}

.fp-folder-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--fp-text);
  margin: 0;
  line-height: 1.3;
}

.fp-folder-meta {
  font-size: 11px;
  color: var(--fp-text-3);
  margin: 0;
}

.fp-file-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border-radius: var(--fp-radius);
  cursor: pointer;
  transition: all var(--fp-transition);
  border: 1px solid transparent;
  margin-bottom: 2px;
}

.fp-file-row:hover {
  background: var(--fp-surface-3);
  border-color: var(--fp-border);
}

.fp-file-row.fp-file-selected {
  background: var(--fp-accent-dim);
  border-color: rgba(79, 142, 247, 0.25);
}

.fp-file-row.fp-file-selected .fp-file-name {
  color: var(--fp-accent);
}

.fp-file-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}

.fp-file-icon[data-type=danger] {
  background: rgba(240, 96, 96, 0.12);
}

.fp-file-icon[data-type=danger] ion-icon {
  color: #f06060;
}

.fp-file-icon[data-type=success] {
  background: rgba(62, 207, 142, 0.12);
}

.fp-file-icon[data-type=success] ion-icon {
  color: #3ecf8e;
}

.fp-file-icon[data-type=primary] {
  background: rgba(79, 142, 247, 0.12);
}

.fp-file-icon[data-type=primary] ion-icon {
  color: #4f8ef7;
}

.fp-file-icon[data-type=tertiary] {
  background: rgba(167, 139, 250, 0.12);
}

.fp-file-icon[data-type=tertiary] ion-icon {
  color: #a78bfa;
}

.fp-file-icon[data-type=medium] {
  background: none;
}

.fp-file-icon[data-type=medium] ion-icon {
  color: var(--fp-text-3);
}

.fp-file-info {
  flex: 1;
  min-width: 0;
}

.fp-file-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--fp-text-3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  transition: color var(--fp-transition);
}

.fp-file-meta {
  font-size: 11px;
  color: var(--fp-text-2);
  margin: 2px 0 0;
}

.fp-file-size {
  font-size: 11px;
  color: var(--fp-text-3);
  font-family: "DM Mono", monospace;
  white-space: nowrap;
  flex-shrink: 0;
}

.fp-check {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--fp-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all var(--fp-transition);
}

.fp-check.fp-check-active {
  background: var(--fp-accent);
  border-color: var(--fp-accent);
}

.fp-checkmark {
  font-size: 12px;
  color: white;
  font-weight: 700;
}

.fp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: var(--fp-text-3);
  gap: 8px;
}

.fp-empty ion-icon {
  font-size: 36px;
  opacity: 0.4;
}

.fp-empty p {
  font-size: 13px;
  margin: 0;
}

.fp-footer ion-toolbar {
  --background: var(--fp-surface);
  --border-color: var(--fp-border);
}

.fp-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 16px;
}

.fp-selected-info {
  flex: 1;
  min-width: 0;
}

.fp-selected-none {
  font-size: 13px;
  color: var(--fp-text-3);
}

.fp-selected-chip {
  --background: rgba(79, 142, 247, 0.12);
  --color: #4f8ef7;
  border: 1px solid rgba(79, 142, 247, 0.2);
  font-size: 12px;
  max-width: 260px;
}

.fp-selected-chip ion-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fp-footer-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.fp-footer-actions ion-button {
  --border-radius: 8px;
  font-size: 13px;
  height: 36px;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/components/file-picker/file-picker.component.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sCAAA;EACA,wCAAA;EACA,oBAAA;EACA,yCAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mDAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,oCAAA;AAJF;;AAUE;EACE,qBAAA;EACA,uBAAA;EACA,uBAAA;AAPJ;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AARF;;AAWA;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AARF;;AAWA;EACE,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AARF;;AAWA;EACE,iCAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qCAAA;EACA,8BAAA;EACA,sCAAA;EACA,eAAA;EACA,OAAA;AARF;;AAWA;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAUE;EACE,sCAAA;EACA,gBAAA;EACA,0CAAA;AARJ;;AAWE;EACE,qCAAA;EACA,gBAAA;EACA,yCAAA;AATJ;;AAYE;EACE,eAAA;AAVJ;;AAgBA;EACE,oCAAA;EACA,OAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAbF;;AAeE;EACE,yBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAdF;;AAmBA;EACE,YAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAhBF;;AAkBE;EACE,UAAA;AAhBJ;;AAkBE;EACE,+BAAA;EACA,kBAAA;AAhBJ;;AAoBE;EAjBF;IAkBI,aAAA;EAjBF;AACF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;AAjBF;;AAmBE;EACE,+BAAA;EACA,qBAAA;AAjBJ;;AAoBE;EACE,gCAAA;EACA,uBAAA;AAlBJ;;AAmBI;EACE,uBAAA;AAjBN;;AAqBE;EACE,YAAA;EACA,eAAA;EACA,oBAAA;AAnBJ;;AAuBA;EACE,eAAA;EACA,uBAAA;EACA,cAAA;EACA,0CAAA;EACA,eAAA;EACA,YAAA;AApBF;;AAsBE;EACE,qBAAA;AApBJ;;AAwBA;EACE,WAAA;EACA,cAAA;AArBF;;AAwBA;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,sCAAA;AArBF;;AAwBA;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AArBF;;AA0BA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAvBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;AAzBF;;AA2BE;EACE,eAAA;AAzBJ;;AA4BE;EACE,uBAAA;EACA,aAAA;AA1BJ;;AA6BE;EACE,eAAA;EACA,sCAAA;AA3BJ;;AA4BI;EACE,uBAAA;AA1BN;;AA8BE;EACE,uBAAA;EACA,eAAA;AA5BJ;;AA6BI;EACE,uBAAA;AA3BN;;AAkCA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;AA/BF;;AAiCE;EACE,UAAA;AA/BJ;;AAiCE;EACE,4BAAA;EACA,kBAAA;AA/BJ;;AAqCA;EACE,aAAA;EACA,4DAAA;EACA,QAAA;EACA,mBAAA;AAlCF;;AAqCA;EACE,+BAAA;EACA,kCAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAlCF;;AAoCE;EACE,+BAAA;EACA,gCAAA;EACA,2BAAA;EACA,yCAAA;AAlCJ;;AAqCE;EACE,YAAA;EACA,eAAA;EACA,oBAAA;AAnCJ;;AAuCA;EACE,eAAA;EACA,uBAAA;AApCF;;AAuCA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AApCF;;AAuCA;EACE,eAAA;EACA,uBAAA;EACA,SAAA;AApCF;;AAyCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,oCAAA;EACA,6BAAA;EACA,kBAAA;AAtCF;;AAwCE;EACE,+BAAA;EACA,8BAAA;AAtCJ;;AAyCE;EACE,gCAAA;EACA,sCAAA;AAvCJ;;AAyCI;EACE,uBAAA;AAvCN;;AA4CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAzCF;;AA2CE;EACE,mCAAA;AAzCJ;;AA0CI;EACE,cAAA;AAxCN;;AA2CE;EACE,oCAAA;AAzCJ;;AA0CI;EACE,cAAA;AAxCN;;AA2CE;EACE,oCAAA;AAzCJ;;AA0CI;EACE,cAAA;AAxCN;;AA2CE;EACE,qCAAA;AAzCJ;;AA0CI;EACE,cAAA;AAxCN;;AA2CE;EACE,gBAAA;AAzCJ;;AA0CI;EACE,uBAAA;AAxCN;;AA6CA;EACE,OAAA;EACA,YAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,sCAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,uBAAA;EACA,eAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,uBAAA;EACA,iCAAA;EACA,mBAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oCAAA;AA1CF;;AA4CE;EACE,4BAAA;EACA,8BAAA;AA1CJ;;AA8CA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AA3CF;;AAgDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;AA7CF;;AA+CE;EACE,eAAA;EACA,YAAA;AA7CJ;;AA+CE;EACE,eAAA;EACA,SAAA;AA7CJ;;AAoDE;EACE,+BAAA;EACA,gCAAA;AAjDJ;;AAqDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;AAlDF;;AAqDA;EACE,OAAA;EACA,YAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,uBAAA;AAlDF;;AAqDA;EACE,sCAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;AAlDF;;AAoDE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlDJ;;AAsDA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAnDF;;AAqDE;EACE,oBAAA;EACA,eAAA;EACA,YAAA;AAnDJ","sourcesContent":["// ─────────────────────────────────────────────────────────────────────────────\r\n// FILE PICKER MODAL STYLES\r\n// ─────────────────────────────────────────────────────────────────────────────\r\n\r\n:host {\r\n  --fp-bg: #576d7b;\r\n  --fp-surface: #f2f3f8;\r\n  --fp-surface-2: #9aa0b8;\r\n  --fp-surface-3: #eba556;\r\n  --fp-surface-4: #dadada;\r\n  --fp-border: rgba(255, 255, 255, 0.07);\r\n  --fp-border-h: rgba(255, 255, 255, 0.14);\r\n  --fp-accent: #4f8ef7;\r\n  --fp-accent-dim: rgba(79, 142, 247, 0.12);\r\n  --fp-text: #ffffff;\r\n  --fp-text-2: #9aa0b8;\r\n  --fp-text-3: #5a6080;\r\n  --fp-radius: 10px;\r\n  --fp-transition: 180ms cubic-bezier(0.4, 0, 0.2, 1);\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  font-family: \"Titillium\", sans-serif;\r\n}\r\n\r\n// ─── HEADER ──────────────────────────────────────────────────────────────────\r\n\r\n.fp-header {\r\n  ion-toolbar {\r\n    --background: #576d7b;\r\n    --border-color: #576d7b;\r\n    --color: var(--fp-text);\r\n  }\r\n}\r\n\r\n.fp-title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--fp-text);\r\n  letter-spacing: -0.3px;\r\n}\r\n\r\n.fp-subtitle {\r\n  font-size: 12px;\r\n  color: var(--fp-text);\r\n  font-weight: 400;\r\n  margin-top: 1px;\r\n}\r\n\r\n.fp-toolbar {\r\n  --background: var(--fp-surface);\r\n  --border-color: var(--fp-border);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 8px 8px;\r\n}\r\n\r\n.fp-search {\r\n  --background: var(--fp-surface-2);\r\n  --border-radius: 8px;\r\n  --box-shadow: none;\r\n  --color: var(--fp-text);\r\n  --placeholder-color: var(--fp-text-3);\r\n  --icon-color: var(--fp-text-3);\r\n  --clear-button-color: var(--fp-text-3);\r\n  font-size: 13px;\r\n  flex: 1;\r\n}\r\n\r\n.role-chip {\r\n  margin: 0;\r\n  height: 32px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  flex-shrink: 0;\r\n\r\n  &.role-admin {\r\n    --background: rgba(79, 142, 247, 0.12);\r\n    --color: #4f8ef7;\r\n    border: 1px solid rgba(79, 142, 247, 0.25);\r\n  }\r\n\r\n  &.role-restricted {\r\n    --background: rgba(245, 166, 35, 0.1);\r\n    --color: #f5a623;\r\n    border: 1px solid rgba(245, 166, 35, 0.2);\r\n  }\r\n\r\n  ion-icon {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n// ─── CONTENT / BODY ───────────────────────────────────────────────────────────\r\n\r\n.fp-content {\r\n  --background: --ion-background-color;\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.fp-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  gap: 12px;\r\n  color: --ion-text-color;\r\n  font-size: 13px;\r\n\r\n  ion-spinner {\r\n    --color: var(--fp-accent);\r\n  }\r\n}\r\n\r\n.fp-body {\r\n  display: flex;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n// ─── SIDEBAR ──────────────────────────────────────────────────────────────────\r\n\r\n.fp-sidebar {\r\n  width: 240px;\r\n  min-width: 240px;\r\n  border-right: 1px solid --ion-color-primary;\r\n  overflow-y: auto;\r\n  padding: 12px 0;\r\n  background: #e4e4e4;\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 3px;\r\n  }\r\n  &::-webkit-scrollbar-thumb {\r\n    background: --ion-color-primary;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  // Hide on small viewports (ionic handles this naturally on mobile)\r\n  @media (max-width: 540px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.fp-section-label {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.8px;\r\n  color: var(--fp-text-3);\r\n  text-transform: uppercase;\r\n  padding: 4px 16px 8px;\r\n  margin: 0;\r\n}\r\n\r\n.fp-tree-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  height: 34px;\r\n  padding-right: 12px;\r\n  cursor: pointer;\r\n  border-radius: 0;\r\n  transition: background var(--fp-transition);\r\n  font-size: 13px;\r\n  color: var(--fp-text-2);\r\n  user-select: none;\r\n\r\n  &:hover:not(.fp-tree-locked) {\r\n    background: var(--fp-surface-3);\r\n    color: var(--fp-text);\r\n  }\r\n\r\n  &.fp-tree-active {\r\n    background: var(--fp-accent-dim);\r\n    color: var(--fp-accent);\r\n    .fp-tree-icon-active {\r\n      color: var(--fp-accent);\r\n    }\r\n  }\r\n\r\n  &.fp-tree-locked {\r\n    opacity: 0.3;\r\n    cursor: default;\r\n    pointer-events: none;\r\n  }\r\n}\r\n\r\n.fp-tree-toggle {\r\n  font-size: 12px;\r\n  color: var(--fp-text-3);\r\n  flex-shrink: 0;\r\n  transition: transform var(--fp-transition);\r\n  cursor: pointer;\r\n  padding: 4px;\r\n\r\n  &:hover {\r\n    color: var(--fp-text);\r\n  }\r\n}\r\n\r\n.fp-tree-toggle-spacer {\r\n  width: 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fp-tree-icon {\r\n  font-size: 15px;\r\n  flex-shrink: 0;\r\n  color: var(--fp-text-3);\r\n  transition: color var(--fp-transition);\r\n}\r\n\r\n.fp-tree-label {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 13px;\r\n}\r\n\r\n// ─── MAIN PANEL ───────────────────────────────────────────────────────────────\r\n\r\n.fp-main {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n// ─── BREADCRUMB ───────────────────────────────────────────────────────────────\r\n\r\n.fp-breadcrumb {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 10px 20px;\r\n  border-bottom: 1px solid var(--fp-border);\r\n  font-size: 12px;\r\n  color: var(--fp-text-3);\r\n  flex-shrink: 0;\r\n  flex-wrap: wrap;\r\n  background: var(--fp-surface);\r\n\r\n  ion-icon {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .bc-sep {\r\n    color: var(--fp-text-3);\r\n    margin: 0 2px;\r\n  }\r\n\r\n  .bc-item {\r\n    cursor: pointer;\r\n    transition: color var(--fp-transition);\r\n    &:hover {\r\n      color: var(--fp-accent);\r\n    }\r\n  }\r\n\r\n  .bc-current {\r\n    color: var(--fp-text-2);\r\n    cursor: default;\r\n    &:hover {\r\n      color: var(--fp-text-2);\r\n    }\r\n  }\r\n}\r\n\r\n// ─── FILE AREA ────────────────────────────────────────────────────────────────\r\n\r\n.fp-file-area {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 16px 20px;\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 4px;\r\n  }\r\n  &::-webkit-scrollbar-thumb {\r\n    background: var(--fp-border);\r\n    border-radius: 2px;\r\n  }\r\n}\r\n\r\n// ─── FOLDER GRID ──────────────────────────────────────────────────────────────\r\n\r\n.fp-folder-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\r\n  gap: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.fp-folder-card {\r\n  background: var(--fp-surface-4);\r\n  border: 1px solid var(--fp-border);\r\n  border-radius: var(--fp-radius);\r\n  padding: 14px 12px;\r\n  cursor: pointer;\r\n  transition: all var(--fp-transition);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n\r\n  &:hover:not(.fp-folder-locked) {\r\n    background: var(--fp-surface-3);\r\n    border-color: var(--fp-border-h);\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\r\n  }\r\n\r\n  &.fp-folder-locked {\r\n    opacity: 0.3;\r\n    cursor: default;\r\n    pointer-events: none;\r\n  }\r\n}\r\n\r\n.fp-folder-icon {\r\n  font-size: 22px;\r\n  color: var(--fp-accent);\r\n}\r\n\r\n.fp-folder-name {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: var(--fp-text);\r\n  margin: 0;\r\n  line-height: 1.3;\r\n}\r\n\r\n.fp-folder-meta {\r\n  font-size: 11px;\r\n  color: var(--fp-text-3);\r\n  margin: 0;\r\n}\r\n\r\n// ─── FILE ROWS ────────────────────────────────────────────────────────────────\r\n\r\n.fp-file-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 9px 12px;\r\n  border-radius: var(--fp-radius);\r\n  cursor: pointer;\r\n  transition: all var(--fp-transition);\r\n  border: 1px solid transparent;\r\n  margin-bottom: 2px;\r\n\r\n  &:hover {\r\n    background: var(--fp-surface-3);\r\n    border-color: var(--fp-border);\r\n  }\r\n\r\n  &.fp-file-selected {\r\n    background: var(--fp-accent-dim);\r\n    border-color: rgba(79, 142, 247, 0.25);\r\n\r\n    .fp-file-name {\r\n      color: var(--fp-accent);\r\n    }\r\n  }\r\n}\r\n\r\n.fp-file-icon {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  font-size: 16px;\r\n\r\n  &[data-type=\"danger\"] {\r\n    background: rgba(240, 96, 96, 0.12);\r\n    ion-icon {\r\n      color: #f06060;\r\n    }\r\n  }\r\n  &[data-type=\"success\"] {\r\n    background: rgba(62, 207, 142, 0.12);\r\n    ion-icon {\r\n      color: #3ecf8e;\r\n    }\r\n  }\r\n  &[data-type=\"primary\"] {\r\n    background: rgba(79, 142, 247, 0.12);\r\n    ion-icon {\r\n      color: #4f8ef7;\r\n    }\r\n  }\r\n  &[data-type=\"tertiary\"] {\r\n    background: rgba(167, 139, 250, 0.12);\r\n    ion-icon {\r\n      color: #a78bfa;\r\n    }\r\n  }\r\n  &[data-type=\"medium\"] {\r\n    background: none;\r\n    ion-icon {\r\n      color: var(--fp-text-3);\r\n    }\r\n  }\r\n}\r\n\r\n.fp-file-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.fp-file-name {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: var(--fp-text-3);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin: 0;\r\n  transition: color var(--fp-transition);\r\n}\r\n\r\n.fp-file-meta {\r\n  font-size: 11px;\r\n  color: var(--fp-text-2);\r\n  margin: 2px 0 0;\r\n}\r\n\r\n.fp-file-size {\r\n  font-size: 11px;\r\n  color: var(--fp-text-3);\r\n  font-family: \"DM Mono\", monospace;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fp-check {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  border: 2px solid var(--fp-border);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  transition: all var(--fp-transition);\r\n\r\n  &.fp-check-active {\r\n    background: var(--fp-accent);\r\n    border-color: var(--fp-accent);\r\n  }\r\n}\r\n\r\n.fp-checkmark {\r\n  font-size: 12px;\r\n  color: white;\r\n  font-weight: 700;\r\n}\r\n\r\n// ─── EMPTY STATE ──────────────────────────────────────────────────────────────\r\n\r\n.fp-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 200px;\r\n  color: var(--fp-text-3);\r\n  gap: 8px;\r\n\r\n  ion-icon {\r\n    font-size: 36px;\r\n    opacity: 0.4;\r\n  }\r\n  p {\r\n    font-size: 13px;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n// ─── FOOTER ───────────────────────────────────────────────────────────────────\r\n\r\n.fp-footer {\r\n  ion-toolbar {\r\n    --background: var(--fp-surface);\r\n    --border-color: var(--fp-border);\r\n  }\r\n}\r\n\r\n.fp-footer-inner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 8px 16px;\r\n}\r\n\r\n.fp-selected-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.fp-selected-none {\r\n  font-size: 13px;\r\n  color: var(--fp-text-3);\r\n}\r\n\r\n.fp-selected-chip {\r\n  --background: rgba(79, 142, 247, 0.12);\r\n  --color: #4f8ef7;\r\n  border: 1px solid rgba(79, 142, 247, 0.2);\r\n  font-size: 12px;\r\n  max-width: 260px;\r\n\r\n  ion-label {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n.fp-footer-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n\r\n  ion-button {\r\n    --border-radius: 8px;\r\n    font-size: 13px;\r\n    height: 36px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
